import axiosApi from "../axiosInstance";

export async function getFormTypeDropdown(request) {
    try {
        const response = await axiosApi.post(`/formType/GetFormTypeDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getFormTypeDropdown===>:", error);
        return null;
    }
};

export async function getFieldTypeDropdown(request) {
    try {
        request = request ?? { "formTypeId": 0, "isActive": null };
        const response = await axiosApi.post(`/FieldType/GetFieldTypeDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getFieldTypeDropdown===>:", error);
        return null;
    }
};